/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseServiceV2 } from '../property-matrix-base-service-v-2';
import { PropertyMatrixConfigurationV2 } from '../property-matrix-configuration-v-2';
import { PropertyMatrixStrictHttpResponseV2 } from '../property-matrix-strict-http-response-v-2';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class HealthService extends PropertyMatrixBaseServiceV2 {
  constructor(
    config: PropertyMatrixConfigurationV2,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1HealthHealthCheckGet
   */
  static readonly ApiV1HealthHealthCheckGetPath = '/api/v1/Health/HealthCheck';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1HealthHealthCheckGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1HealthHealthCheckGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<string>> {

    const rb = new RequestBuilder(this.rootUrl, HealthService.ApiV1HealthHealthCheckGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1HealthHealthCheckGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1HealthHealthCheckGet(params?: {
    context?: HttpContext
  }
): Observable<string> {

    return this.apiV1HealthHealthCheckGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<string>) => r.body as string)
    );
  }

}
